module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "click-out",
      rawName: "v-click-out",
      value: (_vm.hide),
      expression: "hide"
    }, {
      name: "show",
      rawName: "v-show",
      value: (_vm.show),
      expression: "show"
    }],
    staticClass: "btn-group dropdown",
    class: {
      open: _vm.open
    }
  }, [_c('button', {
    staticClass: "btn btn-sm btn-dark",
    attrs: {
      "data-toggle": "dropdown",
      "tabindex": "1",
      "aria-expanded": "false"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
        return _vm.toggle.apply(null, arguments)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-lock m-r-xs"
  }), _vm._v(" " + _vm._s(_vm.title) + " "), _c('span', {
    staticClass: "caret"
  })]), _vm._v(" "), _c('ul', {
    staticClass: "dropdown-menu no-padder"
  }, _vm._l((_vm.options), function(option, index) {
    return (_vm.ACL.check(option.acl, _vm.currentUser.id)) ? _c('li', {
      key: index
    }, [_c('a', {
      on: {
        "click": function($event) {
          return _vm.$emit(option.emit)
        }
      }
    }, [_c('i', {
      class: ("fa fa-" + (option.icon || 'lock') + " m-r-xs")
    }), _vm._v(" " + _vm._s(option.label) + "\n      ")])]) : _vm._e()
  }), 0)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-d53cb634","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/app/_default/components/BtnOptions.vue
// module id = 2059
// module chunks = 18